module.exports = __webpack_public_path__ + "img/article76.1577df33.jpg";